import Backbone from 'backbone';
import Handlebars from 'handlebars';

import EventHub from '~/eventHub';
import toastr from 'toastr';

import getUserService from '~/services/userService';
import template from '~/templates/header.handlebars'; // template is compiled to 'header.handlebars.js' file

var HeaderView = Backbone.View.extend({
	/**
	* @member [html] className
	*/
	className: 'headerVieww',
	reportID: null,
	notifData: null,
	/**
	* @ignore
	* @constructor
	*/
	initialize: function() {
		
	},
	
	/**
	* @todo check
	*/
	events: {
		'click [data-action="logout"]': 'logout',
		'click #menu_toggle': 'sidebarExpandCollapse',
		'click #notifications-menu-container': 'notifMenuLoad',
		'click .prorroga': 'prorrogaPopUp',
		'click .btnprorroga': 'activateProrroga'
	},
	
	/**
	*
	* @function render
	*/
	render: function() {
		var templateFunc = Handlebars.template(template);
		this.$el.html(templateFunc({})); // we cant use this here before initialize parse.
		if (getUserService().isAuthorized()) {
			// show user details and icon
			this.$el.html(templateFunc({
				user: Parse.User.current(),
				userFormattedName: getUserService().getUserNiceName()
			}));
			this.notifMenuLoad();
		}
		this.listenTo(EventHub, 'login', () => this.onLogin());
		this.listenTo(EventHub, 'logout', () => this.onLogout());
		this.listenTo(EventHub, 'notifMenuLoad', () => this.notifMenuLoad());
		this.translate();
	},
	
	translate: function(e){
		if( lang !='es'){
			this.$el.find('.item').each(function(index, element){
				$(this).text(arrlang[lang][$(this).attr("key")]);
			});
		}
	},
	
	/**
	*
	* @function sidebarExpandCollapse
	*/
	sidebarExpandCollapse: function(e) {
		e.preventDefault();
		EventHub.trigger('sidebarView:expandcollapse');
	},

	prorrogaPopUp: function(e) {
		this.reportID = $(e.currentTarget).attr('id');
		Parse.Cloud.run('DeleteProrrogaNotif', { reportID: this.reportID }).then(() => {

		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
		$('#ProrrogaReportID').text(this.reportID);
		var notifInfo = this.notifData.results;
		for(var i = 0; i < notifInfo.length; ++i){
			if(notifInfo[i].attributes.report.id == this.reportID){
				var report = notifInfo[i].attributes.report;
				console.log(report);
				var date = report.attributes.createdAt;
				date.setDate(date.getDate() + parseInt(this.notifData.delreportdata1));
				var content = '<span key="DelReportDataIntro">Por buenas practicas de protección de datos de los usuarios, el reporte: </span>'+ report.attributes.subCategory.attributes.superCat.attributes.name +' '+ report.attributes.subCategory.attributes.name +' <span key="DelReportDataDate">se eliminaran los datos en la fecha </span>'+ date.toLocaleDateString('en-GB') +'.<br><br><a class="reportlink" href="#report/'+ report.id +'" key="DelReportDataLink">Puede consultar el reporte aqui.</a><br><br><span key="DelReportDataProrroga">O también puede solicitar una prorroga unica por 90 días para atender el caso de ser necesario.</span>';
				$('#reportInfoContainer').html(content);
			}
		}
	},

	activateProrroga: function(e) {
		Parse.Cloud.run("ActivateProrroga", { reportID: this.reportID }).then(function(response) {
			toastr.success(arrlang[lang]["SaveStateok"],"Operación realizada");
			$('#prorrogaModal').modal('hide');
			$('.modal-backdrop').remove();
		},
		function(error) {
			$('#prorrogaModal').modal('hide');
			$('.modal-backdrop').remove();
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},
	
	notifMenuLoad: function() {
		var that = this;
		var userID = {
			userID: Parse.User.current().id
		};
		Parse.Cloud.run("GetNotifications", userID).then((data) => {
			that.notifData = data;
			var notifInfo = data.results;
			var count = data.count;
			var delay = data.delay;
			var content = '<li><span key="NotifMenuTitle" id="notif_Title" class="itemt"> Notificaciones </span></li>';
			for(var i = 0; i < notifInfo.length; ++i){
				if(notifInfo[i].attributes.report){
					switch(notifInfo[i].attributes.kind){
						case 'newreport':
							content += '<li><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><img src="';
							if(notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile){
								content += notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile._url +'" alt="" class="report-img">';
							}
							else{
								content += 'images/new/icons/7sO96C21Pf.svg" alt="" class="report-img">';
							}
							content += '<div class="notif-info"><span class="notif-text">Reporte nuevo de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.name+'</span>';
						break;
						case 'comment':
							content += '<li><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><img src="';
							if(notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile){
								content += notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile._url +'" alt="" class="report-img">';
							}
							else{
								content += 'images/new/icons/7sO96C21Pf.svg" alt="" class="report-img">';
							}
							content += '<div class="notif-info"><span class="notif-text">Comentario nuevo de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.name+'</span>';
						break;
						case 'closereport':
							content += '<li><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><img src="';
							if(notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile){
								content += notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile._url +'" alt="" class="report-img">';
							}
							else{
								content += 'images/new/icons/7sO96C21Pf.svg" alt="" class="report-img">';
							}
							content += '<div class="notif-info"><span class="notif-text">Reporte cerrado de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.name+'</span>';
						break;
						case 'discardreport':
							content += '<li><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><img src="';
							if(notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile){
								content += notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile._url +'" alt="" class="report-img">';
							}
							else{
								content += 'images/new/icons/7sO96C21Pf.svg" alt="" class="report-img">';
							}
							content += '<div class="notif-info"><span class="notif-text">Reporte descartado de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.name+'</span>';
						break;
						case 'noresponse':
							content += '<li><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><img src="';
							if(notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile){
								content += notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.iconFile._url +'" alt="" class="report-img">';
							}
							else{
								content += 'images/new/icons/7sO96C21Pf.svg" alt="" class="report-img">';
							}
							content += '<div class="notif-info"><span class="notif-text">Reporte de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' lleva mas de '+ delay +' dias sin recibir respuesta</span>';
						break;
						case 'deletereportdata':
							content += '<li><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><i class="fa fa-calendar-times report-icon""></i>';
							content += '<div class="notif-info"><span class="notif-text">Datos del reporte de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' fueron eliminados</span>';
						break;
						case 'fordelete':
							content += '<li><a class="open_notif" id="'+ notifInfo[i].attributes.report.id +'" href="#report/'+ notifInfo[i].attributes.report.id +'"><i class="fa fa-calendar-times report-icon""></i>';
							content += '<div class="notif-info"><span class="notif-text">Datos del reporte de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' pronto serán eliminados</span>';
						break;
						case 'prorroga':
							content += '<li><a class="open_notif prorroga" id="'+ notifInfo[i].attributes.report.id +'" data-toggle="modal" data-target="#prorrogaModal"><i class="fa fa-calendar-times report-icon""></i>';
							content += '<div class="notif-info"><span class="notif-text">Datos del reporte de '+ notifInfo[i].attributes.report.attributes.subCategory.attributes.superCat.attributes.name +' pronto serán eliminados. Puede solicitar una prórroga aquí</span>';
						break;
					}
					var today = new Date();
					if(today.toLocaleDateString('en-GB') == notifInfo[i].createdAt.toLocaleDateString('en-GB')){
						content += '<span class="notif-date">'+ arrlang[lang]["notifToday"]+ '</span></div>';
					}
					else{
						content += '<span class="notif-date">'+ notifInfo[i].createdAt.toLocaleDateString('en-GB') +'</span></div>';
					}
					if(notifInfo[i].attributes.kind == 'noresponse'){
						content += '<i class="fa fa-exclamation-circle noresponseicon"></i>';
					}
					content += '</a></li>';
				}
			}
			content += '<li><a href="#notifications" class="see-all-txt"><span key="NotifMenuSeeAll" class="itemt">ver más </span></a></li>';
			var alertsBadge = '';
			if(count > 99){
				alertsBadge = '99+';
			}
			else{
				alertsBadge = ''+count;
			}
			$("#notif-container").html(content);
			$("#notif_bar_badge_count").html(alertsBadge);
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},

	/**
	*
	* @function onLogin
	*/
	onLogin: function() {
		this.render();
	},
	
	/**
	*
	* @function onLogout
	*/
	onLogout: function() {
		this.render();
	},
	
	/**
	*
	* @function logout
	*/
	logout: function() {
		getUserService().logOut();
	}
});

/**
 *
 * Module headerView
 * @module views/headerView
 * @returns html
 */
export default HeaderView;
